<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!identifiedItemConfig.enabled" (click)="toggleEnabled()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="identifiedItemConfig.default">
    @if (!isMobile()) {
      <input type="text" class="form-control name-input" placeholder="{{ derivedName }}"
        [disabled]="!identifiedItemConfig.enabled"
        [(ngModel)]="identifiedItemConfig.name" (change)="updateFilter()">
      <span class="sep"></span>
    }
    <app-select [(ngModel)]="identifiedItemConfig.itemTier" (selectedValueChange)="updateFilter()" style="width: 75px;">
      <app-option [value]="ItemTier.Excellent" text="Excel."></app-option>
      <app-option [value]="ItemTier.Good" text="Good"></app-option>
    </app-select>
    <span class="sep"></span>
    <app-select-comparator [(ngModel)]="identifiedItemConfig.rarityComparator" [allowLessThanOrEqual]="false" (selectedValueChange)="updateFilter()"></app-select-comparator>
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="false" [includeUnique]="false" [includeNormal]="false" [disabled]="!identifiedItemConfig.enabled" [(ngModel)]="identifiedItemConfig.rarity" (selectedValueChange)="updateFilter()"></app-select-rarity>
    <span class="sep"></span>
    <app-select [(ngModel)]="identifiedItemConfig.type" (selectedValueChange)="updateFilter()" style="min-width: 50px;">
      <app-option [value]="IdentifiedItemConfigType.Equipment" text="Equipment" dropdownText="Equipment" imgUrl="/img/all-items.png"></app-option>
      <app-option [value]="IdentifiedItemConfigType.Jewels" text="Jewels" dropdownText="Jewels" imgUrl="/img/all-jewels.png"></app-option>
    </app-select>
    @if (identifiedItemConfig.type === IdentifiedItemConfigType.Equipment) {
      <span class="sep"></span>
      <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!identifiedItemConfig.enabled" [(ngModel)]="identifiedItemConfig.minGearTier" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
    }
    <span class="sep"></span>
    <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="width: 55px;"
      [disabled]="!identifiedItemConfig.enabled"
      [(ngModel)]="identifiedItemConfig.minILevel" (change)="updateFilter()">
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn toggle-button customize-btn" [class.active]="conditionsOpen" [class.disabled]="!identifiedItemConfig.enabled"
        (click)="conditionsOpen = !conditionsOpen">
        <span class="icon icon-equalizer"></span>
      </button>
    </span>

  @if (identifiedItemConfig.default) {
    <span class="sep"></span>
    <div class="remove-btn-placeholder">
    </div>
  } @else {
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeIdentifiedItemConfiguration()"></button>
    </span>
  }
  </span>
</div>
@if (conditionsOpen) {
  <app-mod-quality-filters [config]="identifiedItemConfig" (configChange)="updateFilter()"></app-mod-quality-filters>
}
